// extracted by mini-css-extract-plugin
export default {"background":"overlay_background__pwl5k","shown":"overlay_shown__6HS2S"};